export default __webpack_public_path__ + "static/media/41_3_0.c9ebcd25.png";